import classnames from 'classnames';
import React from 'react';
import { useWizard } from 'react-use-wizard';

import Icon from '../icon/Icon';
import { noop } from 'lodash';

interface BreadcrumbStepProps {
  stepIndex: number;
  stepLabel: string;
  name: string;
  disabled: boolean;
}

const BreadcrumbStep: React.FC<BreadcrumbStepProps> = ({
  stepIndex,
  stepLabel,
  name,
  disabled,
}) => {
  const { goToStep, activeStep } = useWizard();

  const handleClick = () => {
    goToStep(stepIndex);
  };

  const isVisited = activeStep > stepIndex;

  return (
    <div
      className={classnames('BreadcrumbStep', {
        visited: isVisited,
        isCurrentStep: activeStep === stepIndex,
      })}
    >
      <div className='thread' />
      <div className='globe' onClick={!disabled ? handleClick : noop}>
        {isVisited && activeStep !== stepIndex ? (
          <Icon icon='tick' />
        ) : (
          stepLabel
        )}
      </div>
      <p className='name mb-0 d-block'>{name}</p>
    </div>
  );
};

export default BreadcrumbStep;
